import React from 'react';
import Icon from '../../../components/AppIcon';

const FamilyOverviewPanel = ({ children }) => {
  const getTotalStats = () => {
    return {
      totalQuizzes: children?.reduce((sum, child) => sum + child?.quizCompleted, 0),
      totalRecommendations: children?.reduce((sum, child) => sum + child?.recommendationsReceived, 0),
      totalAchievements: children?.reduce((sum, child) => sum + child?.achievementsUnlocked, 0),
      averageEngagement: Math.round(
        children?.reduce((sum, child) => sum + child?.engagementScore, 0) / children?.length
      )
    };
  };

  const stats = getTotalStats();

  const overviewMetrics = [
    {
      icon: 'Users',
      title: 'Enfants Inscrits',
      value: children?.length?.toString(),
      subtitle: 'Profils actifs',
      color: 'blue'
    },
    {
      icon: 'ClipboardCheck',
      title: 'Quiz Complétés',
      value: stats?.totalQuizzes?.toString(),
      subtitle: 'Total famille',
      color: 'green'
    },
    {
      icon: 'Lightbulb',
      title: 'Recommandations',
      value: stats?.totalRecommendations?.toString(),
      subtitle: 'Reçues au total',
      color: 'amber'
    },
    {
      icon: 'Award',
      title: 'Badges Gagnés',
      value: stats?.totalAchievements?.toString(),
      subtitle: 'Tous enfants',
      color: 'purple'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 text-blue-600',
    green: 'bg-green-50 border-green-200 text-green-600',
    amber: 'bg-amber-50 border-amber-200 text-amber-600',
    purple: 'bg-purple-50 border-purple-200 text-purple-600'
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Home" size={24} className="text-primary" />
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Vue d'Ensemble Familiale
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {overviewMetrics?.map((metric, index) => (
          <div
            key={index}
            className={`rounded-lg p-4 border ${colorClasses?.[metric?.color]}`}
          >
            <div className="flex items-center gap-3 mb-3">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-white`}>
                <Icon name={metric?.icon} size={20} className={colorClasses?.[metric?.color]?.split(' ')?.[2]} />
              </div>
              <div className="flex-1">
                <p className="text-2xl font-bold text-gray-900">{metric?.value}</p>
              </div>
            </div>
            <p className="text-sm font-semibold text-gray-900 mb-1">{metric?.title}</p>
            <p className="text-xs text-gray-600">{metric?.subtitle}</p>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6 border border-blue-200">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="TrendingUp" size={24} className="text-blue-600" />
          <h3 className="text-lg font-semibold text-gray-900">
            Engagement Familial Moyen
          </h3>
        </div>
        <div className="flex items-end gap-4">
          <div className="flex-1">
            <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
              <div
                className="bg-gradient-to-r from-blue-500 to-purple-500 h-4 rounded-full transition-all duration-500"
                style={{ width: `${stats?.averageEngagement}%` }}
              />
            </div>
            <p className="text-sm text-gray-600">
              Vos enfants sont activement engagés dans leur parcours d'orientation
            </p>
          </div>
          <div className="text-right">
            <p className="text-3xl font-bold text-blue-600">{stats?.averageEngagement}%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyOverviewPanel;